import React, { useState } from 'react'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Box } from 'transfix-ui/core'
import { SwitchIcon } from 'transfix-icons'
import { useUserDetails } from 'utils/hooks'
import { EdiMergeFacilityModal } from './components/EdiMergeFacilityModal'
import { EdiWarningMessage } from './components/WarningMessage'
import { useWarningMessageInfoQuery } from './graphql/WarningMessageInfo'

export interface IEdiDuplicateFacilitiesWarningMessageProps {
  shipmentId?: string
  shipperApplicationId?: string
  shipperFacilityUuid?: string
  facilityUuid?: string
  onSuccess?: () => void
}

export const EdiDuplicateFacilitiesWarningMessage = ({
  facilityUuid,
  onSuccess,
  shipmentId,
  shipperApplicationId,
  shipperFacilityUuid,
}: IEdiDuplicateFacilitiesWarningMessageProps) => {
  const { userPermissions } = useUserDetails()
  const { canMergeFacilitiesToPrimary, canReviewFacilities } = userPermissions || {}
  const canViewMergeFacilityMenu = canMergeFacilitiesToPrimary || canReviewFacilities
  const [open, setOpen] = useState<boolean>(false)
  const { data } = useWarningMessageInfoQuery({
    variables: { shipmentId: shipmentId || '' },
    skip: !shipmentId,
  })
  const { shipment } = data || {}
  const { uuid: shipperFacilityUuidFromStops = '' } =
    shipment?.stops
      .map(({ shipperFacility }) => shipperFacility)
      .find(({ facility }) => facility.uuid === facilityUuid) || {}

  if (!canViewMergeFacilityMenu) {
    return null
  }

  return (
    <>
      <Box gridArea='warning'>
        <InlineMessage
          type={INLINE_MESSAGE_VARIANTS.WARNING}
          message={<EdiWarningMessage onReview={() => setOpen(true)} />}
          IconComponent={SwitchIcon}
        />
      </Box>
      <EdiMergeFacilityModal
        open={open}
        shipmentId={shipmentId}
        shipperApplicationId={shipperApplicationId}
        shipperFacilityUuid={shipperFacilityUuid || shipperFacilityUuidFromStops || ''}
        onClose={() => setOpen(false)}
        onSuccess={onSuccess}
      />
    </>
  )
}
